import RelocationChild from "./relocationChild";

import Address from "../address";
import * as R from "ramda";

export default function RelocationDeclaration(data) {
	let representing = data || {};
	let professions = [];
	if (!R.isNil(representing.professionalSituation)) {
		if (!Array.isArray(representing.professionalSituation)) {
			let allProfs = representing.professionalSituation.split(", ");
			if (Array.isArray(allProfs)) {
				allProfs.forEach((p) => {
					professions.push(p.trim());
				});
			} else {
				professions.push(allProfs);
			}
		}
		else {
			representing.professionalSituation.forEach((p) => {
				professions.push(p.trim());
			});
		}
	}

	this.id = representing.id;
	this.processNumber = representing.processNumber;

	this.effectiveMovingDate = R.isNil(representing.effectiveMovingDate) ? undefined : representing.effectiveMovingDate === "0001-01-01T00:00:00Z" ? undefined : new Date(representing.effectiveMovingDate);
	this.allocations = R.isNil(representing.allocations) ? [] : representing.allocations;
	this.houseHoldCount = representing.houseHoldCount;
	this.civilStatus = representing.civilStatus;
	this.gender = representing.gender;

	this.onBoardingStep = representing.onBoardingStep || 1;
	this.hasChildren = representing.hasChildren;
	this.children = R.isNil(representing.children) ? [] : representing.children.map((c) => new RelocationChild(c));
	this.hasPets = representing.hasPets;

	this.email = representing.email;
	this.phoneNumber = representing.phoneNumber;

	this.firstName = R.isNil(representing.firstName) ? "" : representing.firstName;
	this.lastName = R.isNil(representing.lastName) ? "" : representing.lastName;

	// this.professionalSituation = professions;
	this.professionalSituation = professions;
	this.partnerId = representing.partnerId;
	this.etablissementId = representing.etablissementId;

	this.userId = representing.userId;
	this.declaringUserId = representing.declaringUserId;
	this.oldAddress = new Address(representing.oldAddress);
	this.newAddress = new Address(representing.newAddress);

	this.movingType = representing.movingType;
	this.reason = representing.reason;
	this.sameArea = representing.sameArea;
}
